import { render, staticRenderFns } from "./CadastroRelatorioDialog.vue?vue&type=template&id=fad5cfdc"
import script from "./CadastroRelatorioDialog.vue?vue&type=script&lang=js"
export * from "./CadastroRelatorioDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports